// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".ace2722af6ece323bc3832c543be23145e4d7681.chunk.js";
};